module.exports = __webpack_public_path__ + "img/maroccan.4db25ba9.jpg";